// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__ICYsJ","circle":"Loader_circle__w+Az0","shadow":"Loader_shadow__MvvpP"};